// extracted by mini-css-extract-plugin
module.exports = {"canClick":"Breadcrumb_canClick__22C7t","icon":"Breadcrumb_icon__2LTU4","color":"Breadcrumb_color__3lH9f"};